import { useQuery } from '@tanstack/react-query';
import vlqrApi, { handleError } from 'utils/vlqrApi';

const getProjectSessionSummaryReportsOverview = async (projectId) => {
    const { data } = await vlqrApi.get(`projects/${projectId}/sessionSummaryReportsOverview?reportTypeFilter=SessionSummary`)
        .catch((error) => {
            handleError(error);
        });

    return data;
};

const useProjectSessionSummaryReportsOverview = (projectId, pollInterval = false) => {
    const { data, refetch, isLoading, isError } = useQuery({
        queryKey: ['projectSessionSummaryReportsOverview', projectId],
        queryFn: () => getProjectSessionSummaryReportsOverview(projectId),
        refetchInterval: pollInterval
    });

    return { data, refetch, isLoading, isError };
};

export default useProjectSessionSummaryReportsOverview;
